import React, { useEffect } from "react";
import { useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { Col } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import Loaders from "../../../assets/loaders/loaders";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { IoChevronBackCircleOutline } from "react-icons/io5";
import { useCreateUrlCampMutation } from "../../../services/post";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../layouts/sidebar";
import WindowHead from "../../layouts/windowHead";


export default function CreateCampaign() {
    const navigate = useNavigate();
    const [showNav, setShowNav] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const [createUrlCamp] = useCreateUrlCampMutation();
    const [name, setName] = useState();
    const [expiryDate, setExpiryDate] = useState();
    const [expiryTime, setExpiryTime] = useState();
    const [url, setUrl] = useState();
    const [category, setCategory] = useState();

    const [validated, setValidated] = useState(false);
    const [error1, setError1] = useState('');


    const explanations = (e) => {
        const pattern = /^[a-zA-Z0-9_]*$/;

        if (pattern.test(e.target.value) === false) {
            setError1('No special characters or spaces allowed.');
        } else {
            setError1('');
            setName(e.target.value);
        }
    }


    const [urlInvalid, setUrlInvalid] = useState(false);
    const handleUrl = (e) => {
        const urlgiven = e.target.value;
        // eslint-disable-next-line 
        if (urlgiven.match(/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}([\/\w .-]*)*\/?$/)) {
            setUrl(urlgiven);
            setUrlInvalid(false);
        } else {
            setUrlInvalid(true);
        }

    }


    useEffect(() => {
        fetchData();
    }, [])

    const [options, setOptions] = useState([]);
    const fetchData = async () => {
        fetch(
            `${process.env.REACT_APP_API_BASE_URL}/header_drop_down`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("tokenn")
                }
            })
            .then((res) => res.json())
            .then(
                (result) => {
                    let data = result.data?.map(key => key.header);
                    setOptions(data);
                },
                (error) => {
                    toast.error(error.message);
                    setOptions([]);
                }
            );
    };
    const [selectedHeader, setSelectedHeader] = useState("");
    const [isTouched, setIsTouched] = useState(false);
    const handleSelectChange = (event) => {
        setSelectedHeader(event.target.value);
        setIsTouched(true);
    };

    const handleSubmit = async (event) => {
        setIsTouched(true);

        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false || !selectedHeader) {
            event.stopPropagation();
        } else {
            try {
                const postData = {
                    long_url: url,
                    url_name: name,
                    expiry_in: `${expiryDate} ${expiryTime}`,
                    category: category,
                    header: selectedHeader,
                }

                const response = await createUrlCamp(postData);

                setIsLoading(true);
                if (response?.data?.statusCode === 200) {
                    setIsLoading(false);
                    toast.success("Campaign Created", { autoClose: 2000 });
                    setTimeout(() => {
                        navigate('/manageUrl');
                    }, 2000);
                } else {
                    setIsLoading(false);
                    toast.error(response?.data?.message || "An error occurred");
                }
            } catch (error) {
                setIsLoading(false);
                toast.error(error.message || "An error occurred");
            }
        }
        setValidated(true);
    };



    return (
        <>
            <ToastContainer />
            {isLoading && <Loaders />}

            <div className="bg-inner">
                <Sidebar show={showNav} onClose={() => setShowNav(false)} />
                <div className="d-flex flex-column ms-0 ms-xxl-3 col-12 col-sm-12 col-xxl-9">
                    <WindowHead sidebarOpen={() => setShowNav(!showNav)} />


                    <div className="main-content">
                        <div className="d-flex for-border">
                            <span>
                                <h4 className="m-0">Create New URL</h4>
                                <p>Provide the below Details to create a New URL Campaign.</p>
                            </span>
                            <button onClick={() => navigate('/manageUrl')} className="ms-auto icon-btn">
                                <IoChevronBackCircleOutline className="icon-grey" />
                            </button>
                        </div>

                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <Row className="mt-3">

                                <Form.Group as={Col} md="6" controlId="validationCustom01" className="mb-4">
                                    <InputGroup hasValidation>
                                        <InputGroup.Text id="inputGroupPrepend">URL Name: </InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            placeholder="ABcd"
                                            onChange={(e) => explanations(e)}
                                            minLength={1}
                                            maxLength={50}
                                            pattern="^[a-zA-Z0-9_]*$"
                                            aria-describedby="inputGroupPrepend"
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {error1 && <div>{error1}</div>}
                                            Please provide a Campaign Name.
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>

                                <Form.Group as={Col} md="3" lg="3" controlId="validationCustom02" className="mb-4">
                                    <InputGroup hasValidation>
                                        <InputGroup.Text id="inputGroupPrepend">Expiry Date:</InputGroup.Text>

                                        <Form.Control
                                            type="date"
                                            onChange={(e) => setExpiryDate(e.target.value)}
                                            aria-describedby="inputGroupPrepend"
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide an Expiry Date.
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>

                                <Form.Group as={Col} md="3" lg="3" controlId="validationCustom02" className="mb-4">
                                    <InputGroup hasValidation>
                                        <InputGroup.Text id="inputGroupPrepend">Expiry Time:</InputGroup.Text>

                                        <Form.Control
                                            type="time"
                                            onChange={(e) => setExpiryTime(e.target.value)}
                                            aria-describedby="inputGroupPrepend"
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide an Expiry Time.
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Row>

                            <Row className="d-flex align-items-start">

                                <Form.Group as={Col} md="6" controlId="validationCustom03" className="mb-4">
                                    <InputGroup hasValidation>
                                        <InputGroup.Text id="inputGroupPrepend">Category: </InputGroup.Text>
                                        <Form.Select
                                            onChange={(e) => setCategory(e.target.value)}
                                            required
                                        >
                                            <option value="">Select an option</option>
                                            <option value="Promotional">Promotional</option>
                                            <option value="Transactional">Transactional</option>
                                            <option value="OTP">OTP</option>
                                        </Form.Select>

                                        <Form.Control.Feedback type="invalid">
                                            Please provide a Category.
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>

                                <Form.Group as={Col} md="6" controlId="validationCustom05" className="mb-4">
                                    <InputGroup hasValidation>
                                        <InputGroup.Text id="inputGroupPrepend">Header: </InputGroup.Text>
                                        <Form.Select value={selectedHeader} onChange={handleSelectChange} isInvalid={isTouched && selectedHeader === ""}>
                                            <option value="">Select Header</option>
                                            {options.map((option, index) => (
                                                <option key={index} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid Header.
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>

                            </Row>

                            <Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="validationCustom05" className="mb-4">
                                    <InputGroup hasValidation>
                                        <InputGroup.Text id="inputGroupPrepend">Long URL: </InputGroup.Text>
                                        <Form.Control
                                            type="url"
                                            pattern="^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}([\/\w .-]*)*\/?$"
                                            placeholder="https://example.com"
                                            aria-describedby="inputGroupPrepend"
                                            onChange={(e) => handleUrl(e)}
                                            isInvalid={urlInvalid}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid URL.
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>

                            </Row>

                            <Button type="submit" className="btn add_btn ms-auto">Submit</Button>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
}